import React from 'react'
import { SHr, SNavigation, SNotification, SPage, SText, STheme, SView } from 'servisofts-component2'
import Container from '../../Components/Container';
import Verified_icon from '../../Assets/verified_icon.svg';
import Check_document from '../../Assets/check_document.svg';
import MDL from '../../MDL';
import Carga_truck from '../../Assets/carga_truck.svg';
import Truck from '../../Assets/truck.svg';
import Coche from '../../Assets/_coche.svg';
import Furgoneta from '../../Assets/_furgoneta.svg';
import { ScrollView } from 'react-native-gesture-handler';

export default class ChecklistAssignedTrailer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkRemolques: {},
            checkTractora: false,
            dni: "",
            matricula: "",
            tipo_vehiculo_id: "",
            posting: false,
            error: null,
            expediciones: [],
            registros: [],
            registrosRemolques: {},
            errorFields: {},
        };
    }
    componentDidMount() {
        this.loadData();
    }
    async loadData() {
        const session = MDL.usuario?.session;
        if (!session) return;
        const dni = String(session?.sDNI ?? '').trim();
        const matricula = String(session?.plate ?? '').trim();
        const lc = await MDL.checklist.__loginChofer({
            dni: MDL.usuario.session?.sDNI ?? "",
            matricula: MDL.usuario.session?.plate ?? "",
        })
        // console.clear();
        console.log("%c" + JSON.stringify(lc, null, 2), "color: #2ECC40; font-weight: bold;");
        // const expediciones = lc.expediciones;

        const tipo_vehiculo_id = String(lc?.tipo_vehiculo_id ?? '').trim();
        const descripcion = String(lc?.descripcion ?? '').trim();
        const sModelo = String(lc?.sModelo ?? '').trim();
        const expediciones = Array.isArray(lc?.expediciones) ? lc.expediciones : [];
        console.log("🚀 session expediciones:", expediciones);
        if (!dni || !matricula) return;
        const checkRemolques = {};
        expediciones.forEach((exp, index) => {
            const key = String(exp?.sRemolque ?? index).trim();
            checkRemolques[key] = false;
        });
        this.loadChecklist();
        this.setState({ dni, matricula, tipo_vehiculo_id, descripcion, sModelo, expediciones, checkRemolques, }, () => {
            this.loadChecklist();
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.dni !== this.state.dni ||
            prevState.matricula !== this.state.matricula ||
            prevState.tipo_vehiculo_id !== this.state.tipo_vehiculo_id
        ) {
            this.loadChecklist();
        }
    }
    loadChecklist = async () => {
        const nextTipoId = String(this.state.tipo_vehiculo_id || '').trim();
        const dniStr = String(this.state.dni ?? "").trim();
        const matriculaStr = String(this.state.matricula ?? "").trim();
        const expediciones = Array.isArray(this.state.expediciones) ? this.state.expediciones : [];
        if (!nextTipoId || !dniStr || !matriculaStr) {
            console.log("❌ loadChecklist abortado por datos incompletos");
            return;
        }

        try {
            let registros = [];
            try {
                const res = await MDL.checklist.getChecklistRegistros(dniStr, matriculaStr);
                registros = Array.isArray(res) ? res : [];
            } catch (e) {
                console.log("⚠️ tractora sin registros (normalizado a [])", e?.message);
                registros = [];
            }

            console.log("📊 registros tractora:", registros);
            const registrosRemolques = {};

            await Promise.all(
                expediciones.map(async (exp) => {
                    const remolque = String(exp?.sRemolque ?? '').trim();
                    if (!remolque) return;
                    console.log("🔎 consultando remolque:", remolque);
                    try {
                        const res = await MDL.checklist.getChecklistRegistros(dniStr, remolque);
                        registrosRemolques[remolque] = Array.isArray(res) ? res : [];
                        console.log("📦 remolque OK:", remolque, registrosRemolques[remolque].length);
                    } catch (e) {
                        console.log("❌ remolque error (normalizado):", remolque);
                        registrosRemolques[remolque] = [];
                    }
                })
            );
            console.log("✅ FINAL registrosRemolques:", registrosRemolques);
            this.setState({ registros, registrosRemolques });
        } catch (error) {
            console.log("❌ ERROR GENERAL loadChecklist:", error);

            this.setState({ registros: [], registrosRemolques: {} });
        }
    };

    onPostLista = async () => {
        const { checkTractora, checkRemolques, dni, matricula, tipo_vehiculo_id, expediciones } = this.state;
        this.setState({ posting: true, error: null });
        try {
            let vehiculoMatricula = matricula;
            let vehiculoTipoId = tipo_vehiculo_id;
            let state = 1;
            if (!checkTractora) {
                const selectedRemolqueKey = Object.keys(checkRemolques).find(idx => checkRemolques[idx]);
                if (selectedRemolqueKey !== undefined) {
                    const remolqueIndex = parseInt(selectedRemolqueKey);
                    if (expediciones[remolqueIndex]) {
                        vehiculoMatricula = String(expediciones[remolqueIndex]?.sRemolque ?? matricula).trim();
                        vehiculoTipoId = String(expediciones[remolqueIndex]?.tipo_vehiculo_id ?? tipo_vehiculo_id);
                    }
                }
            }

            const body = {
                state,
                matricula: vehiculoMatricula,
                dni,
                tipo_vehiculo_id: vehiculoTipoId,
                completado: 0,
            };
            const postResponse = await MDL.checklist.postChecklistLista(body);
            this.setState({ posting: false });
            return postResponse;
        } catch (error) {
            this.setState({
                posting: false,
                error: error?.message || String(error),
            });
            throw error;
        }
    }

    render() {
        const { checkRemolques, checkTractora, matricula, posting, error, tipo_vehiculo_id, expediciones, registros, registrosRemolques, descripcion, sModelo } = this.state;

        const formatearFechaHora = (fechaStr) => {
            const fecha = new Date(fechaStr);
            const dia = fecha.getDate();
            const mes = fecha.toLocaleDateString('es-ES', { month: 'short' });
            const anio = fecha.getFullYear();
            const minutos = String(fecha.getMinutes()).padStart(2, '0');
            const ampm = fecha.getHours() >= 12 ? 'pm' : 'am';
            const horaFormato = fecha.getHours() > 12 ? fecha.getHours() - 12 : fecha.getHours() === 0 ? 12 : fecha.getHours();
            return `${dia} ${mes} ${anio} · ${horaFormato}:${minutos} ${ampm}`;
        };

        const ultimoRegistro = Array.isArray(registros) && registros.length > 0
            ? '29 abr 2026 · 5:21 am'
            : 'N/A';
        // console.log("%c" + JSON.stringify(registrosRemolques, null, 2), "color: #cca72e; font-weight: bold;");

        // console.clear();
        console.log("%c" + JSON.stringify(checkTractora, null, 2), "color: #2ECC40; font-weight: bold;");
        // console.log("%c" + JSON.stringify(expediciones, null, 2), "color: #2ECC40; font-weight: bold;");
        const getUltimoRegistroRemolque = (remolqueMatricula) => {
            if (!remolqueMatricula) return 'N/A';
            const regs = registrosRemolques?.[remolqueMatricula];
            // console.log("%c" + JSON.stringify(regs, null, 2), "color: #2ECC40; font-weight: bold;");
            if (Array.isArray(regs) && regs.length > 0) {
                return formatearFechaHora(regs[0]?.created_at);
            }
            return 'N/A';
        };

        const formatHora = (horaString) => {
            if (!horaString) return '';
            const [horaMinuto] = horaString.split('.')[0].split(':');
            const hora = parseInt(horaMinuto, 10);
            const minuto = horaString.split(':')[1];
            const ampm = hora >= 12 ? 'pm' : 'am';
            const horaFormato = hora > 12 ? hora - 12 : hora === 0 ? 12 : hora;
            return `${horaFormato}:${minuto} ${ampm}`;
        };
        const remolquesUnicos = expediciones.reduce((acc, exp, index) => {
            const key = String(exp?.sRemolque || '').trim();
            if (!key) return acc;

            if (!acc[key]) {
                acc[key] = { exp, indices: [] };
            }
            acc[key].indices.push(index);
            return acc;
        }, {});

        const remolquesArray = Object.entries(remolquesUnicos).map(([key, data]) => ({
            sRemolque: key,
            ...data,
        }));

        const ningunoSeleccionado = Object.values(checkRemolques).every(v => !checkRemolques[v])
        // console.log("%cCHECKLIST", "color:#2ECC40;font-weight:bold;");
        // console.log(ultimoRegistro);
        return (
            <SPage center disableScroll>
                <Container flex >
                    <SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 24, borderRadius: 16, alignItems: "center", justifyContent: "space-between", }}>
                        <SView col={"xs-12"} center style={{ alignItems: "center" }} row>
                            <Verified_icon width={18} height={18} fill={STheme.color.danger} style={{ marginRight: 8 }} />
                            <SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}> TIEMPO DE CHECKLIST </SText>
                            <SHr height={10} />
                            <SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
                        </SView>
                        <SView col='xs-12' flex row center style={{ overflow: 'auto', flexWrap: 'wrap', justifyContent: 'space-around', alignContent: 'flex-start', }} backgroundColor={"transparent"} >

                            <ScrollView
                                ref={(ref) => { this.questionsScrollRef = ref; }}
                                style={{ flex: 1, width: '100%' }}
                                onScroll={(event) => {
                                    this.lastScrollY = event?.nativeEvent?.contentOffset?.y ?? 0;
                                }}
                                scrollEventThrottle={16}
                                contentContainerStyle={{ paddingBottom: 100, flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around' }}
                                keyboardShouldPersistTaps="handled"
                                showsVerticalScrollIndicator>
                                <SHr height={35} />

                                <SView col={"xs-12"} center row>
                                    <SView col={"xs-9"} center>
                                        <SText font='AlbertSans' bold center fontSize={22} color={STheme.color.text}>Seleccionar Remolques Asignados</SText>
                                    </SView>

                                    <SHr height={30} />
                                    {expediciones.length > 0 && (
                                        <>
                                            <SView col={"xs-12"} center >
                                                <SView col={"xs-10"} center style={{ marginBottom: 10 }}>
                                                    <SView center row style={{ width: '100%', justifyContent: 'space-between', paddingHorizontal: 10, opacity: ultimoRegistro !== 'N/A' ? 0.5 : 1 }}>
                                                        <SView style={{ flex: 1 }}>
                                                            <SText font='AlbertSans' center fontSize={18} color={checkTractora ? STheme.color.text : STheme.color.white + '99'} style={{ textTransform: 'capitalize' }}  >{descripcion ? descripcion + " " + matricula : "Tractora"}</SText>
                                                            {/* <SText font='AlbertSans' center fontSize={18} color={STheme.color.text}>Tractora {String(matricula)}</SText> */}
                                                            {ultimoRegistro !== 'N/A' && (<SText font='AlbertSans' center fontSize={10} color={STheme.color.secondary}>{ultimoRegistro}</SText>
                                                            )}
                                                        </SView>
                                                        <SView onPress={() => {
                                                            if (ultimoRegistro !== 'N/A') return;
                                                            this.setState((prev) => {
                                                                const nextCheckTractora = !prev.checkTractora;
                                                                const emptyRemolques = {};
                                                                Object.keys(prev.checkRemolques).forEach(key => {
                                                                    emptyRemolques[key] = false;
                                                                });
                                                                return {
                                                                    checkTractora: nextCheckTractora,
                                                                    checkRemolques: nextCheckTractora ? emptyRemolques : prev.checkRemolques,
                                                                    errorFields: {},
                                                                };
                                                            });
                                                        }}>
                                                            {checkTractora ? <Check_document width={23} height={21} fill={STheme.color.secondary} /> : <SView width={22.5} height={21} center style={{ borderRadius: 2, borderWidth: 2, borderColor: this.state.errorFields.tractora && !checkTractora && ningunoSeleccionado ? ultimoRegistro !== 'N/A' ? STheme.color.gray : STheme.color.danger : STheme.color.gray, }} />}
                                                        </SView>
                                                    </SView>
                                                </SView>
                                                {remolquesArray.map((remolque) => {
                                                    const firstIndex = remolque.indices[0];
                                                    const isCheckedRemolque = checkRemolques[String(firstIndex)];
                                                    getUltimoRegistroRemolque(remolque.sRemolque)
                                                    const horasCarga = remolque.indices.map(idx => expediciones[idx]?.tHoraCarga).filter(Boolean);
                                                    const remolqueHasRevision = getUltimoRegistroRemolque(remolque.sRemolque) !== 'N/A';
                                                    return (
                                                        <SView key={remolque.sRemolque} col={"xs-10"} center style={{ marginBottom: 8 }}>
                                                            <SView center row style={{ width: '100%', justifyContent: 'space-between', paddingHorizontal: 10, opacity: remolqueHasRevision ? 0.5 : 1 }}>
                                                                <SView style={{ flex: 1 }}>
                                                                    <SText font='AlbertSans' center fontSize={18} color={STheme.color.text}>Remolque {remolque.sRemolque}</SText>
                                                                </SView>
                                                                <SView onPress={() => {
                                                                    this.setState((prev) => {
                                                                        const newCheckRemolques = {};
                                                                        Object.keys(prev.checkRemolques).forEach(key => {
                                                                            newCheckRemolques[key] = false;
                                                                        });
                                                                        newCheckRemolques[String(firstIndex)] = !prev.checkRemolques[String(firstIndex)];
                                                                        return {
                                                                            checkRemolques: newCheckRemolques,
                                                                            checkTractora: false,
                                                                            errorFields: {},
                                                                        };
                                                                    });
                                                                }}>
                                                                    {isCheckedRemolque ? <Check_document width={23} height={21} fill={STheme.color.secondary} /> :
                                                                        <SView width={22.5} height={21} center style={{ borderRadius: 2, borderWidth: 2, borderColor: this.state.errorFields[`remolque_${firstIndex}`] && !isCheckedRemolque && !checkTractora && ningunoSeleccionado ? remolqueHasRevision ? STheme.color.gray : STheme.color.danger : STheme.color.gray, }} />}
                                                                </SView>
                                                            </SView>
                                                            {horasCarga.map((hora, idx) => {
                                                                const numerosTexto = ['Primera', 'Segunda', 'Tercera', 'Cuarta', 'Quinta', 'Sexta', 'Séptima', 'Octava'];
                                                                const numeroTexto = numerosTexto[idx] || `Carga ${idx + 1}`;
                                                                const horaFormateada = formatHora(hora);
                                                                return (
                                                                    <SText key={idx} font='AlbertSans' center fontSize={11} color={STheme.color.text} style={{ opacity: remolqueHasRevision ? 0.5 : 1 }}>{numeroTexto} carga - {horaFormateada}</SText>
                                                                );
                                                            })}
                                                        </SView>
                                                    );
                                                })}
                                            </SView>
                                        </>
                                    )}
                                    <SHr height={30} /></SView>
                                <SView
                                    width={143}
                                    height={150}
                                    center
                                    onPress={() => {
                                        if (ultimoRegistro !== 'N/A') return;
                                        this.setState((prev) => {
                                            const nextCheckTractora = !prev.checkTractora;
                                            const emptyRemolques = {};
                                            Object.keys(prev.checkRemolques).forEach(key => {
                                                emptyRemolques[key] = false;
                                            });
                                            return {
                                                checkTractora: nextCheckTractora,
                                                checkRemolques: nextCheckTractora ? emptyRemolques : prev.checkRemolques,
                                                checkTractoraRequired: nextCheckTractora ? false : prev.checkTractoraRequired,
                                            };
                                        });
                                    }}
                                    style={{
                                        marginBottom: ultimoRegistro === 'N/A' ? 8 : 36,
                                        borderRadius: 14,
                                        backgroundColor: checkTractora ? STheme.color.primary : STheme.color.gray,
                                        borderWidth: ultimoRegistro !== 'N/A' ? 0 : 2,
                                        borderColor: this.state.errorFields.tractora && !checkTractora && ningunoSeleccionado ? ultimoRegistro === 'N/A' ? STheme.color.danger : STheme.color.gray : "transparent",
                                        opacity: ultimoRegistro !== 'N/A' ? 0.5 : 1
                                    }} >
                                    {/* <Coche width={74} height={75} fill={checkTractora ? STheme.color.secondary : STheme.color.white + '66'} /> */}

                                    {descripcion === 'COCHE' && (<Coche width={74} height={75} fill={checkTractora ? STheme.color.secondary : STheme.color.white + '66'} />)}
                                    {descripcion === 'FURGONETA' ? (<Furgoneta width={74} height={75} fill={checkTractora ? STheme.color.secondary : STheme.color.white + '66'} />) :
                                        <Truck width={74} height={75} fill={checkTractora ? STheme.color.secondary : STheme.color.white + '66'} />
                                    }

                                    <SHr height={8} />
                                    <SView col={"xs-11.5"} center>
                                        <SText font='AlbertSans' center fontSize={18} color={checkTractora ? STheme.color.text : STheme.color.white + '99'} style={{ textTransform: 'capitalize' }}  >{descripcion ? descripcion : "Tractora"}</SText>
                                        <SText width={"100%"} font='AlbertSans' center fontSize={12} color={checkTractora ? STheme.color.text : STheme.color.white + '99'} style={{ textTransform: 'capitalize' }} numberOfLines={1}   >{sModelo ? sModelo : "modelo"}</SText>
                                    </SView>
                                    <SView col={"xs-11"} center>
                                        <SText font='AlbertSans' center fontSize={18} color={checkTractora ? STheme.color.text : STheme.color.white + '99'}>{matricula}</SText>
                                        <SText font='AlbertSans' center fontSize={10} color={checkTractora ? STheme.color.text : STheme.color.white + '99'} style={{ textTransform: 'capitalize' }}  >{tipo_vehiculo_id ? tipo_vehiculo_id : "tipo"}</SText>
                                    </SView>
                                    {
                                        ultimoRegistro !== 'N/A' ?
                                            <SView col={"xs-12"} center style={{ position: "absolute", bottom: -32 }} >
                                                <SText font='AlbertSans' center fontSize={10} bold color={STheme.color.text}>Última revisión</SText>
                                                <SHr height={2} />
                                                <SText font='AlbertSans' center fontSize={11} bold color={STheme.color.secondary}>{ultimoRegistro}</SText>
                                            </SView>
                                            : null}
                                </SView>
                                {remolquesArray.map((remolque) => {
                                    const firstIndex = remolque.indices[0];
                                    const isCheckedRemolque = checkRemolques[String(firstIndex)];
                                    const horasCarga = remolque.indices.map(idx => expediciones[idx]?.tHoraCarga).filter(Boolean);
                                    const mostrar = getUltimoRegistroRemolque(remolque.sRemolque);

                                    // console.clear();
                                    console.log("%c" + JSON.stringify(remolque, null, 2), "color: #cc2eb2; font-weight: bold;");
                                    return (
                                        <SView
                                            key={remolque.sRemolque}
                                            width={143}
                                            height={150}
                                            center
                                            onPress={() => {
                                                console.log(remolque)
                                                if (getUltimoRegistroRemolque(remolque.sRemolque) !== 'N/A') return;
                                                this.setState((prev) => {
                                                    const newCheckRemolques = {};
                                                    Object.keys(prev.checkRemolques).forEach(key => {
                                                        newCheckRemolques[key] = false;
                                                    });
                                                    newCheckRemolques[String(firstIndex)] = !prev.checkRemolques[String(firstIndex)];
                                                    return {
                                                        checkRemolques: newCheckRemolques,
                                                        checkTractora: false,
                                                    };
                                                });
                                            }}
                                            style={{
                                                marginBottom: mostrar === 'N/A' ? 8 : 36, borderRadius: 14, backgroundColor: isCheckedRemolque ? STheme.color.primary : STheme.color.gray, borderWidth: mostrar !== 'N/A' ? 0 : 2,
                                                borderColor: this.state.errorFields[`remolque_${firstIndex}`] && !isCheckedRemolque && !checkTractora && ningunoSeleccionado ? mostrar === 'N/A' ? STheme.color.danger : STheme.color.gray : "transparent",
                                                opacity: mostrar !== 'N/A' ? 0.5 : 1
                                            }}
                                        >
                                            <Carga_truck width={99} height={75} fill={isCheckedRemolque ? STheme.color.secondary : STheme.color.white + '66'} />
                                            <SHr height={8} />
                                            <SView col={"xs-9"} center>
                                                <SText font='AlbertSans' center fontSize={18} color={isCheckedRemolque ? STheme.color.text : STheme.color.white + '99'}>{remolque.exp.sDescripcion}</SText>
                                                <SText width={"100%"} font='AlbertSans' center fontSize={12} color={isCheckedRemolque ? STheme.color.text : STheme.color.white + '99'} style={{ textTransform: 'capitalize' }} numberOfLines={1}   >{remolque.exp.sModelo}</SText>
                                            </SView>
                                            <SView col={"xs-11.5"} center>
                                                <SText font='AlbertSans' center fontSize={18} color={isCheckedRemolque ? STheme.color.text : STheme.color.white + '99'}>{remolque.sRemolque}</SText>
                                                <SText width={"100%"} font='AlbertSans' center fontSize={8} color={isCheckedRemolque ? STheme.color.text : STheme.color.white + '99'} style={{ textTransform: 'capitalize' }} numberOfLines={1}   >{remolque.exp.tipo_vehiculo_id}</SText>
                                            </SView>
                                            {mostrar !== 'N/A' ? <SView col={"xs-12"} center style={{ position: "absolute", bottom: -32 }} >
                                                <SText font='AlbertSans' center fontSize={10} bold color={STheme.color.text}>Última revisión</SText>
                                                <SText font='AlbertSans' center fontSize={11} bold color={STheme.color.secondary}>{mostrar}</SText>
                                            </SView> : null}
                                        </SView>
                                    );
                                })}
                            </ScrollView>
                        </SView>
                        <SView col={"xs-12"}>
                            <SView col={"xs-12"} height={50} center style={{ borderRadius: 8, backgroundColor: STheme.color.secondary }}
                                onPress={async () => {
                                    if (posting) return;

                                    const algunVehiculoSeleccionado = checkTractora || Object.values(checkRemolques).some(Boolean);
                                    const nextErrorFields = {};
                                    if (!algunVehiculoSeleccionado) {
                                        nextErrorFields.tractora = true;
                                        Object.keys(checkRemolques).forEach(key => {
                                            nextErrorFields[`remolque_${key}`] = true;
                                        });
                                        this.setState({ errorFields: nextErrorFields });
                                        SNotification.send({
                                            key: "checklist_obligatorio",
                                            title: "Seleccion obligatoria",
                                            body: "Debes seleccionar Tractora o Remolque para continuar.",
                                            color: STheme.color.danger,
                                            time: 3000,
                                        });
                                        return;
                                    }
                                    let tieneRevision = false;
                                    if (checkTractora) {
                                        tieneRevision = ultimoRegistro !== 'N/A';
                                    } else {
                                        const selectedRemolqueKey = Object.keys(checkRemolques).find(idx => checkRemolques[idx]);
                                        if (selectedRemolqueKey !== undefined) {
                                            const remolqueIndex = parseInt(selectedRemolqueKey);
                                            tieneRevision = getUltimoRegistroRemolque(expediciones[remolqueIndex]?.sRemolque) !== 'N/A';
                                        }
                                    }

                                    if (tieneRevision) {
                                        if (checkTractora) {
                                            nextErrorFields.tractora = true;
                                        } else {
                                            const selectedRemolqueKey = Object.keys(checkRemolques).find(idx => checkRemolques[idx]);
                                            if (selectedRemolqueKey !== undefined) {
                                                const remolqueIndex = parseInt(selectedRemolqueKey);
                                                nextErrorFields[`remolque_${remolqueIndex}`] = true;
                                            }
                                        }
                                        this.setState({ errorFields: nextErrorFields });
                                        SNotification.send({
                                            key: "checklist_con_revision",
                                            title: "Revisión existente",
                                            body: "Este vehículo ya tiene una revisión registrada. Solo puedes registrar vehículos sin revisión.",
                                            color: STheme.color.danger,
                                            time: 3000,
                                        });
                                        return;
                                    }
                                    this.setState({ errorFields: {} });
                                    try {
                                        const postResponse = await this.onPostLista();
                                        SNotification.send({ key: "checklist_ok", title: "Checklist guardado", body: "Se registró correctamente.", color: STheme.color.success, time: 3000, });
                                        const id_capturado = postResponse?.inserted?.[0]?.id;
                                        if (id_capturado) {
                                            let vehiculoTipoId = tipo_vehiculo_id;
                                            let expedicionId = null;
                                            if (checkTractora) {
                                                vehiculoTipoId = tipo_vehiculo_id;
                                            } else {
                                                const selectedRemolqueKey = Object.keys(checkRemolques).find(idx => checkRemolques[idx]);
                                                if (selectedRemolqueKey !== undefined) {
                                                    const remolqueIndex = parseInt(selectedRemolqueKey);
                                                    if (expediciones[remolqueIndex]) {
                                                        vehiculoTipoId = String(expediciones[remolqueIndex]?.tipo_vehiculo_id ?? tipo_vehiculo_id);
                                                        expedicionId = expediciones[remolqueIndex]?.lExpedicionReal_id;
                                                    }
                                                }
                                            }

                                            SNavigation.navigate('/check/ChecklistQuestion', {
                                                id: id_capturado,
                                                tipo_vehiculo_id: vehiculoTipoId,
                                                expedicion_id: expedicionId,
                                                es_tractora: checkTractora,
                                            });
                                        }
                                    } catch {
                                        SNotification.send({
                                            key: "checklist_error",
                                            title: "No se pudo guardar",
                                            body: "Verifica tu conexion e intenta nuevamente.",
                                            color: STheme.color.danger,
                                            time: 3000,
                                        });
                                    }
                                }} >
                                <SText font='AlbertSans' bold color={STheme.color.primary} fontSize={20}> ACEPTAR </SText>
                            </SView>
                            {error ? (
                                <>
                                    <SHr height={8} />
                                    <SText color={STheme.color.danger}>{error}</SText>
                                </>
                            ) : null}
                        </SView>

                    </SView>
                </Container>
                <SHr height={20} />
            </SPage>
        );
    }
}